<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
                <div>我的位置：</div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="xinxi" :to="{ path: '/zhiboshuju' }"
                ><span >直播数据</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div style="display: flex; align-items: center">
              <span>直播数据</span>
              <div class="riqi">
                <el-date-picker
                  v-model="value1"
                    type="daterange"
                  @change='onPick'
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <div
                @click="Query"
                style="
                  font-size: 14px;
                  color: #ffffff;
                  text-align: center;
                  line-height: 28px;
                  width: 60px;
                  height: 28px;
                  background: #721edc;
    cursor: pointer;

                  border-radius: 4px;
                "
              >
                查询
              </div>
            </div>
            <div
              style="
                width: 100%;
                margin-top: 20px;
                padding-bottom: 20px;
                height: 80%;
                overflow: hidden;
              "
            >
              <div
                style="
                  width: calc(100% + 25px);
                  height: 100%;
                "
                v-loading="loadingData"
              >
                <div
                  style="
                    line-height: 40px;
                    display: flex;
                    width: 99%;
                    font-size: 16px;
                    height: 40px;
                    background-color: rgba(250, 246, 255, 1);
                    color: rgba(51, 51, 51, 1);
                  "
                >
                  <div style="width: 21%; text-align: center">开播时间</div>
                  <div style="width: 30%; text-align: center">开播名称</div>
                  <div style="width: 30%; text-align: center">直播时长</div>
                  <div style="width: 15%; text-align: center">开播分类</div>
                  <div style="width: 19%; text-align: center">在线人数(人)</div>
                  <div style="width: 19%; text-align: center">本场收益(元)</div>
                </div>
                <div style="overflow-y: scroll;max-height:100%;min-height: 100px;"  >
                   <div
                  v-for="(item, index) in pageData"
                  :key="index"
                  style="
                    line-height: 37px;
                    display: flex;
                    width: 99%;
                    box-sizing: border-box;
                    padding:0 10px;
                    height: 37px;
                    background-color: rgba(247, 248, 250, 1);
                    font-size: 14px;
                    border-bottom: 1px solid rgba(0,0,0,.1);
                  "
                >
                  <div style="width: 21%; color: rgba(102, 102, 102, 1); text-align: center">
                    {{ dateFormat(item.createTime) }}
                  </div>
                  <div style="width: 30%; color: rgba(102, 102, 102, 1); text-align: center">
                    {{ item.title }}
                  </div>
                  <div style="width: 30%; color: rgba(102, 102, 102, 1); text-align: center">
                    {{ dateCalculation(item.startTime, item.endTime) }}
                  </div>
                  <div style="width: 15%; color: rgba(102, 102, 102, 1); text-align: center">
                    {{ item.categoryName }}
                  </div>
                  <div style="width: 19%; color: rgba(102, 102, 102, 1); text-align: center">
                    {{ item.onlineNum }}
                  </div>
                  <div style="width: 19%; color: #44d7b6; text-align: center">
                    {{ item.income }}
                  </div>
                </div>
                </div>
                <div class="pagenumber" v-if="zhiboData.length>0">
                  <el-pagination
                    background
                    @current-change='currentChange'
                    layout="prev, pager, next"
                    :page-size="10"
                    :total="zhiboData.length">
                  </el-pagination>
                </div>
                <div
                  v-if="zhiboData.length==0 "
                  style="
                    color: #d5d5d5;
                    width: 100%;
                    text-align: center;
                  "
                >
                  <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
                  <div style="font-size: 18px; margin-top: 20px">
                    你还没有直播数据，赶快去直播吧～
                  </div>
                </div>
               <!-- <div
                  v-show="meishuju2"
                  style="
                    color: #d5d5d5;
                    width: 100%;
                    text-align: center;
                  "
                >
                  <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
                  <div style="font-size: 18px; margin-top: 20px">
                    快去查询直播数据吧～
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
export default {
  name: "App",
  data() {
    return {
      loadingData:false,
      b: 3,
      value1: null,
      zhiboData: [],
      pageData:[],
      pageCount:0,
      meishuju: false, //没数据提示
      meishuju2: true, //查询数据
      activeName: 3,
      shijian: null, //直播时间
    };
  },
  mounted() {
    //       var testDate = new Date();
    //       console.log(testDate);
    // // toString() 把 Date 对象转换为字符串。
    // var dateobj_toString = testDate.getTime().toString();
    // console.log(dateobj_toString);

  },
  created() {
    let times = new Date();
    let time = new Date(times.toLocaleDateString())
    this.value1 = [time, time]
    console.log('加载直播数据',this.value1);
    this.Query();
  },
  methods: {
      changeSlide(data){
              this.$router.push(data);
            },
    currentChange(e){
      let i = (e - 1) * 10
      this.pageData =  this.zhiboData.slice(i,i + 10)
      console.log(this.pageData,e);
    },
    onPick(e){
      let startTime =new Date(e[0]).toLocaleDateString()
      let endTime =new Date(e[1]).toLocaleDateString()
      console.log('选中时间',e,startTime,endTime,this.value1);
    },
    dateFormat: function (time) {
      var times = time * 1000;
      var date = new Date(times);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    dateCalculation: function (kaishi, jieshu) {
      //返回天、时、分
      var second = jieshu - kaishi;
      // console.log(second);
      if (second > 0) {
        var day = 0;
        var hour = 0;
        var minute = 0;
        minute = Math.floor(second / 60);
        // console.log(minute);
        if (parseInt(minute) > 60) {
          hour = parseInt(minute / 60);
          minute %= 60; //算出有多分钟
        }
        if (parseInt(hour) > 24) {
          day = parseInt(hour / 24);
          hour %= 24; //算出有多分钟
        }
        // console.log(day+"天"+hour+"小时"+minute+"分");
        return day + "天" + hour + "小时" + minute + "分";
      }
    },
    Query() {
      this.loadingData = true;
      this.$axios
        .get(this.api + "/v1/live/datas", {
          params: {
            startTime: this.value1[0].getTime().toString() / 1000,
            endTime: this.value1[1].getTime().toString() / 1000,
          },
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.loadingData = false
          // console.log(res);
          if (res.data.data.length == 0) {
            this.meishuju = true;

          } else {
            if(res.data.code == 200){
              this.meishuju2 = false;
              this.zhiboData = res.data.data.reverse();
              this.pageCount = Math.ceil(this.zhiboData.length / 10)
              this.pageData =this.zhiboData.slice(0,10)

              console.log('页码',this.pageCount);
            }

          }

        });
        setTimeout(()=>{
          this.loadingData = false
        },4000)

    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e, i) {
      console.log(e, i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>

<style scoped lang='scss'>

 @import "../assets/style/personMain.css"; //引入全局scss
 .personal {
  width: 100vw;
  background: #f7f8fa;
  .pagenumber{
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}
.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  box-sizing: border-box;
  margin-top: 15px;
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.xinxi:hover {
  color: #721edc;
}
.personal-bottom-bottom-right-bottom-top {
  /* width: 100%; */
  display: flex;
  height: 130px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  height: 100px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  /* height: 100px; */
  width: 100%;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
</style>
<style>
.el-pager li.active{
  color: #fff;
  background-color: #721EDC !important
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.xzcxzcxz {
  color: white;
}
.riqi {
  margin: 0 10px;
}
.riqi .el-input__inner {
  background-color: #f1f1f1;
  /* border: 1px #464646 solid; */
}
.riqi .el-date-editor .el-range-input {
  background-color: #f1f1f1;
}
.riqi .el-date-editor .el-range-separator {
}
</style>
<style>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-right .el-collapse-item__header {
  background: #000 !important;
}
.el-collapse-item__wrap {
  background-color: #f7f8fa !important;
}

.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/component/Zhiboshuju.vue